module.exports = __webpack_public_path__ + "img/123.dc831727.jpg";